<template>
  <DashboardLayout>
    <MembersIndex />
    <div class="pb-16"></div>
  </DashboardLayout>
</template>

<script>
// @ is an alias to /src
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import MembersIndex from '@/components/dashboard/members/MembersIndex.vue';

export default {
  name: 'EmplyeesView',
  components: {
    DashboardLayout,
    MembersIndex,
  },
};
</script>
